import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-unified-privacy-policy',
  templateUrl: './unified-privacy-policy.component.html',
  styleUrl: './unified-privacy-policy.component.scss',
  encapsulation: ViewEncapsulation?.None,
  standalone: false
})
export class UnifiedPrivacyPolicyComponent {



}
